import {request} from "../../../../utils/APIRequestService";
import {HttpRequest} from "../../../../enums/http.methods";

const GET_RESULT_MANAGER_LIST = "/get_all_result_manager_user";
const ADD_SUPERVISOR = "/add_supervisor";
const ADD_RESULT_MANAGER_USER="/add_result_manager_user"
const GET_ALL_COMPANIES = "/get_all_companies";
const UPDATE_SUPERVISOR_STATUS = "/update_supervisor_status";
const ADD_ASSIGN_COMPANYS ="/assign_companys";
const GET_CAMERA_LABEL_MAPPING_BY_COMPANY_ID ="/get_camera_label_mapping_by_company_id";
const GET_CAMERA_ENABLED_LOCATIONS ="/get_company_enabled_locations";
const GET_ALL_COMPANY_USERS ="/get_all_company_users";
const GET_TOTAL_CAMERAS_BY_LOCATION_ID ="/get_total_cameras_by_location_id";
const UPDATE_RESULT_MANAGER_STATUS ="/update_result_manager_status";

// New endpoints for camera label mapping
const ADD_CAMERA_LABEL_MAPPING = "/add_camera_label_mapping";
const UPDATE_CAMERA_UPDATE_MAPPING = "/update_camera_update_mapping";

export async function getResultManagerList() {
  return await request({
    endpoint: GET_RESULT_MANAGER_LIST,
    method: HttpRequest.POST,
  });
}
export async function getCameraEnabledLocations(company_id) {
    return await request({
        endpoint: GET_CAMERA_ENABLED_LOCATIONS +"?company_id=" +company_id,
        method: HttpRequest.GET,
    });
}
export async function getAllCompanyUsers() {
  return await request({
    endpoint: GET_ALL_COMPANY_USERS,
    method: HttpRequest.POST,
  });
}
export async function getTotalCamerasByLocationId(user_id , location_id) {
  return await request({
    endpoint: GET_TOTAL_CAMERAS_BY_LOCATION_ID + '?user_id=' + user_id,
    method: HttpRequest.POST,
      body: JSON.stringify(location_id),
  });
}


export async function getCameraLabelMappingByCompanyId(company_id) {
    return await request({
        endpoint: GET_CAMERA_LABEL_MAPPING_BY_COMPANY_ID  +"?company_id=" +company_id,
        method: HttpRequest.GET,
    });
}


export async function getCompaniesList() {
  return await request({
    endpoint: GET_ALL_COMPANIES,
    method: HttpRequest.GET,
  });
}

export async function addAssignCompanyList(user_id ,parameters) {
  return await request({
    endpoint: ADD_ASSIGN_COMPANYS + '?user_id=' + user_id,
    method: HttpRequest.POST,
    body: parameters,
  });
}

export async function addSupervisor(parameters) {
  return await request({
    endpoint: ADD_SUPERVISOR,
    method: HttpRequest.POST,
    body: parameters,
  });
}

export async function addResultManagerUser(parameters) {
    return await request({
        endpoint: ADD_RESULT_MANAGER_USER,
        method: HttpRequest.POST,
        body: parameters,
    });
}

export async function updateResultStatus(parameters) {
    return await request({
        endpoint: UPDATE_RESULT_MANAGER_STATUS +
            "?user_status=" +
            parameters.user_status +
            "&user_id=" +
            parameters.user_id,
        method: HttpRequest.POST,
    });
}

export async function updateSupervisorStatus(parameters) {
  return await request({
    endpoint:
        UPDATE_SUPERVISOR_STATUS +
        "?user_status=" +
        parameters.user_status +
        "&user_id=" +
        parameters.user_id,
    method: HttpRequest.POST,
  });
}

// Add camera label mapping
export async function addCameraLabelMapping(parameters) {
  return await request({
    endpoint: ADD_CAMERA_LABEL_MAPPING,
    method: HttpRequest.POST,
    body: parameters,
  });
}

// Update camera label mapping
export async function updateCameraLabelMapping(parameters) {
  return await request({
    endpoint: UPDATE_CAMERA_UPDATE_MAPPING,
    method: HttpRequest.POST,
    body: parameters,
  });
}
